<div class="d-flex flex-wrap" mat-dialog-title style="margin: unset;padding: 1px 10px 1px 28px;"
    [nbSpinner]="isLoading">
    <button mat-button color="primary" (click)="saveData()" [disabled]="!frm?.valid">
        <mat-icon fontSet=" material-icons-outlined">save</mat-icon>Save
    </button>
    <button mat-button color="primary" (click)="closeDialog()">
        <mat-icon fontSet=" material-icons-outlined">clear</mat-icon>Cancel
    </button>
    <button mat-icon-button aria-label="Close the dialog" [mat-dialog-close]="false" class="ml-auto">
        <mat-icon fontSet=" material-icons-outlined">close</mat-icon>
    </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography" *ngIf="frm">

    <form [formGroup]="frm" class="container" style="padding-top: 25px;padding-right: 50px;padding-left: 50px;">
        <div class="row">
            <div class="col-12" *ngIf="data?.model?.isFromProfile">
                <app-profile-searching (contactSelected)="selectProposal($event)" [label]="environment.titleOpportunity"
                    [typeName]="'OPPORTUNITY'"
                    [placeholderLabel]="'Search ' + environment.titleOpportunity?.toLowerCase() +' name, email or phone...'"
                    [profileId]="dataModel?.proposalId" [disabled]="action == 1 && data?.model?.isFromProfile">
                </app-profile-searching>
            </div>
            <div class="col-12" *ngIf="!data?.model?.isFromProfile">
                <app-profile-searching (contactSelected)="selectPID($event)" (onSelect)="selectPID($event)"
                    [profileId]="dataModel?.profileId" [bankInput]="frm.get('profileId')">
                </app-profile-searching>
            </div>
            <div class="col-12" *ngIf="!data?.model?.isFromProfile">
                <mat-form-field appearance="standard">
                    <mat-label>Status</mat-label>
                    <mat-select required formControlName="automateDataState">
                        <mat-option *ngFor="let status of statusLst" [value]="status.value">
                            {{status.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="standard">
                    <mat-label>Order</mat-label>
                    <input matInput autocomplete="off" formControlName="order" trim="blur">
                    <mat-error *ngIf="frm.controls.order.errors && (frm.controls.order.dirty ||
                             frm.controls.order.touched)">
                        {{frm.controls.order['errorMessage']}}</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="standard">
                    <mat-label>Quantity</mat-label>
                    <input matInput autocomplete="off" formControlName="quantity" mask="separator.0" thousandSeparator="," [dropSpecialCharacters]="true">
                    <mat-error *ngIf="frm.controls.quantity.errors && (frm.controls.quantity.dirty ||
                             frm.controls.quantity.touched)">
                        {{frm.controls.quantity['errorMessage']}}</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="standard">
                    <mat-label>Artist Fee</mat-label>
                    <input matInput autocomplete="off" formControlName="artistFee"  mask="separator.2" thousandSeparator="," >
                    <mat-error *ngIf="frm.controls.artistFee.errors && (frm.controls.artistFee.dirty
                            || frm.controls.artistFee.touched)">
                        {{frm.controls.artistFee['errorMessage']}}</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="standard">
                    <mat-label>Total Artist Fee (Est.)</mat-label>
                    <input matInput autocomplete="off" readonly formControlName="estTotalArtistFee"  mask="separator.2" thousandSeparator=",">
                </mat-form-field>
            </div>

            <div class="col-12">
                <mat-form-field appearance="standard">
                    <mat-label>Fee to Client</mat-label>
                    <input matInput autocomplete="off" formControlName="feeToClient"  mask="separator.2" thousandSeparator="," >
                    <mat-error *ngIf="frm.controls.feeToClient.errors && (frm.controls.feeToClient.dirty ||
                             frm.controls.feeToClient.touched)">
                        {{frm.controls.feeToClient['errorMessage']}}</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="standard">
                    <mat-label>Total Client Fee (Est.)</mat-label>
                    <input matInput autocomplete="off" readonly formControlName="estTotalClientFee"  mask="separator.2" thousandSeparator=",">
                </mat-form-field>
            </div>

            <div class="col-12 mb-4">
                <div>
                    <div style="height: fit-content">
                        <mat-label style="color: #666666; font-size: 12px">Fee to Client Description</mat-label>
                        <quill-editor [modules]="editorOptions" placeholder="Type your text here" formControlName="priceDescription">
                        </quill-editor>
                    </div>
                </div>
            </div>
            <div class="col-12 mt-2 mb-2 d-flex justify-content-between p-3" style="background: #f1f5f9; border-radius: 8px; border: 1px dashed #cbd5e1;">
                <div class="d-flex flex-column">
                    <span style="font-size: 11px; text-transform: uppercase; color: #64748b; font-weight: 600;">Items Total Cost</span>
                    <span class="font-weight-bold" style="font-size: 16px; color: #334155;">{{ formatCurrencyText(totalItemsCost) }}</span>
                </div>
                <div class="d-flex flex-column text-right">
                    <span style="font-size: 11px; text-transform: uppercase; color: #64748b; font-weight: 600;">Items Total Fee</span>
                    <span class="font-weight-bold" style="font-size: 16px; color: #0f766e;">{{ formatCurrencyText(totalItemsClientFee) }}</span>
                </div>
            </div>
            <div class="col-12 mt-3 mb-4">
                <div class="dynamic-items-container">
                    <div class="header-section">
                        <span class="title">Dynamic Line Items</span>
                        <button type="button" mat-stroked-button color="primary" (click)="addLineItem()">
                            <mat-icon fontSet="material-icons-outlined">add</mat-icon> Add Line Item
                        </button>
                    </div>
                    
                    <div style="max-height: 250px; overflow-y: auto;" *ngIf="feeItems && feeItems.length > 0; else noItems">
                        <div class="item-card" *ngFor="let item of feeItems; let i = index">
                            <div class="item-info">
                                <span class="item-name">{{ item.name }}</span>
                                <span class="item-details">
                                    <span>Cost: <strong>{{ formatCurrencyText(item.cost) }}</strong></span>
                                    <span class="text-muted">|</span>
                                    <span>Fee: <strong>{{ formatCurrencyText(item.clientFee) }}</strong></span>
                                    <span *ngIf="item.visibleToClient" class="badge-client-visible ml-2">Visible to client</span>
                                </span>
                            </div>
                            <div class="action-buttons">
                                <button type="button" mat-icon-button color="primary" (click)="editLineItem(item, i)">
                                    <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                                </button>
                                <button type="button" mat-icon-button color="warn" (click)="deleteLineItem(i)">
                                    <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <ng-template #noItems>
                        <div class="no-items-placeholder">
                            <mat-icon fontSet="material-icons-outlined" style="font-size: 28px; width: 28px; height: 28px; margin-bottom: 8px; color: #94a3b8;">playlist_add</mat-icon>
                            <span>No dynamic items added yet.</span>
                        </div>
                    </ng-template>
                </div>
            </div>

            <mat-accordion class="col-12 w-100 mb-3" style="padding: 0;">
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title class="font-weight-bold text-muted" style="font-size: 13px;">
                            Legacy Fees & Inclusions
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row">
                        <div class="col-12 mt-2">
                            <mat-form-field appearance="standard" class="w-100">
                                <mat-label>Fee Includes</mat-label>
                                <textarea cdkTextareaAutosize matInput autocomplete="off" formControlName="feeIncludes" trim="blur"
                                    rows="2" placeholder="Press enter for the new line"></textarea>
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="standard" class="w-100">
                                <mat-label>Fee Excludes</mat-label>
                                <textarea cdkTextareaAutosize matInput autocomplete="off" formControlName="feeExcludes" trim="blur"
                                    rows="2" placeholder="Press enter for the new line"></textarea>
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="standard" class="w-100">
                                <mat-label>Travel</mat-label>
                                <input matInput autocomplete="off" formControlName="travel"  mask="separator.2" thousandSeparator="," >
                                <mat-error *ngIf="frm.controls.travel.errors && (frm.controls.travel.dirty ||
                                         frm.controls.travel.touched)">
                                    {{frm.controls.travel['errorMessage']}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="standard" class="w-100">
                                <mat-label>Accommodation</mat-label>
                                <input matInput autocomplete="off" formControlName="accommodation"  mask="separator.2" thousandSeparator=",">
                                <mat-error *ngIf="frm.controls.accommodation.errors && (frm.controls.accommodation.dirty ||
                                         frm.controls.accommodation.touched)">
                                    {{frm.controls.accommodation['errorMessage']}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="standard" class="w-100">
                                <mat-label>Shipping</mat-label>
                                <input matInput autocomplete="off" formControlName="shipping"  mask="separator.2" thousandSeparator=",">
                                <mat-error *ngIf="frm.controls.shipping.errors && (frm.controls.shipping.dirty ||
                                         frm.controls.shipping.touched)">
                                    {{frm.controls.shipping['errorMessage']}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="standard" class="w-100">
                                <mat-label>Per Diem</mat-label>
                                <input matInput autocomplete="off" formControlName="perDiem"  mask="separator.2" thousandSeparator=",">
                                <mat-error *ngIf="frm.controls.perDiem.errors && (frm.controls.perDiem.dirty ||
                                         frm.controls.perDiem.touched)">
                                    {{frm.controls.perDiem['errorMessage']}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field appearance="standard" class="w-100">
                                <mat-label>Third-Party Commission</mat-label>
                                <input matInput autocomplete="off" formControlName="thirdPartyCommission"  mask="separator.2" thousandSeparator=",">
                                <mat-error *ngIf="frm.controls.thirdPartyCommission.errors && (frm.controls.thirdPartyCommission.dirty ||
                                         frm.controls.thirdPartyCommission.touched)">
                                    {{frm.controls.thirdPartyCommission['errorMessage']}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>

            <div class="col-12">
                <mat-form-field appearance="standard">
                    <mat-label>Total</mat-label>
                    <input matInput autocomplete="off" readonly [ngModel]="total"  mask="separator.2" thousandSeparator=","
                        [ngModelOptions]="{standalone: true}">
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="standard">
                    <mat-label>Total Client Fee</mat-label>
                    <input matInput autocomplete="off" readonly [ngModel]="totalClientFeeCombined" mask="separator.2" thousandSeparator=","
                        [ngModelOptions]="{standalone: true}">
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>
